import ModalHeader from '@molecules/ModalHeader';
import ModalWindow from '@organisms/modals/ModalWindow';
import {FC, useEffect, useState} from 'react';
import {
  ButtonsWrapper,
  ModalContent,
  ModalWrapper,
} from './EditNotificationsSettingsModal.styles';
import Button from '@atoms/Button';
import {NotificationNew} from '@carbon/icons-react';
import {theme} from '@styles/theme';
import Text from '@atoms/Text';
import {ISystem} from '@types';
import {
  CheckboxListBlock,
  CheckboxListRow,
  GreyBlockWrapper,
} from '@organisms/modals/AddEditModuleModal.styles';
import Checkbox from '@atoms/Checkbox';
import Select from '@atoms/Select';
import {toast} from 'react-toastify';
import Toast from '@atoms/Toast';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch, RootState} from '@store';
import {deleteSystemNotificationsSettings, setSystemNotificationsSettings} from '@store/slices/systems';

interface Props {
  isOpened: boolean;
  onCloseRequest: () => void;
  system?: ISystem;
}

const EditNotificationsSettingsModal: FC<Props> = ({
  isOpened,
  onCloseRequest,
  system,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const notificationSettings = useSelector(
    (state: RootState) => state.systems.notificationSettings,
  );
  const [intervalType, setIntervalType] = useState(
    String(notificationSettings.interval_type),
  );
  const [notificationType, setNotificationType] = useState<number[]>(
    notificationSettings.notification_type,
  );

  useEffect(() => {
    setNotificationType(notificationSettings.notification_type);
    setIntervalType(String(notificationSettings.interval_type));
  }, [notificationSettings]);

  const SaveNotificationsSettings = () => {
    if (intervalType !== '3') {
      dispatch(
        setSystemNotificationsSettings({
          system_id: system?.id || 0,
          interval_type: Number(intervalType),
          notification_type: notificationType,
        }),
      )
        .unwrap()
        .then(() => {
          toast.success(
            <Toast
              title="Готово"
              text={`Настройки уведомлений успешно сохранены`}
              type="success"
            />,
          );
          onCloseRequest();
        })
        .catch((err: any) => {
          toast.error(
            <Toast
              title="Ошибка"
              text={err?.message || 'Не удалось сохранить настройки уведомлений'}
              type="error"
            />,
          );
        });
    } else {
      dispatch(
        deleteSystemNotificationsSettings({
          system_id: system?.id || 0,
        }),
      )
        .unwrap()
        .then(() => {
          toast.success(
            <Toast
              title="Готово"
              text={`Настройки уведомлений успешно удалены`}
              type="success"
            />,
          );
          onCloseRequest();
        })
        .catch((err: any) => {
          toast.error(
            <Toast
              title="Ошибка"
              text={err?.message || 'Не удалось удалить настройки уведомлений'}
              type="error"
            />,
          );
        });
    }
  };

  const handleCheckboxChange = (id: number, isChecked: any) => {
    if (isChecked.target.checked) {
      setNotificationType(prev => [...prev, id]);
    } else {
      setNotificationType(prev => prev.filter(item => item !== id));
    }
  };

  return (
    <ModalWindow isOpen={isOpened} overflowIsVisible>
      <ModalWrapper>
        <ModalHeader
          title={'Настройка уведомлений'}
          onClose={onCloseRequest}
          iconElement={<NotificationNew size={24} fill={theme.colors.basic03} />}
        />
        <ModalContent>
          <Text
            text="Настройте уведомления о необходимости обновить тестовую модель системы:"
            color={theme.colors.basic01}
          />
          <Text text={system?.name || ''} type="bodyM" />
          <GreyBlockWrapper>
            <Text
              text="Высылать уведомления"
              type="captionB"
              color={theme.colors.basic01}
            />
            <CheckboxListBlock>
              <CheckboxListRow>
                <Checkbox
                  id={'1'}
                  label="Администратору системы"
                  checked={notificationType.includes(1)}
                  onChange={value => handleCheckboxChange(1, value)}
                />
              </CheckboxListRow>
              <CheckboxListRow>
                <Checkbox
                  id={'2'}
                  label="Редакторам системы"
                  checked={notificationType.includes(2)}
                  onChange={value => handleCheckboxChange(2, value)}
                />
              </CheckboxListRow>
              <CheckboxListRow>
                <Checkbox
                  id={'3'}
                  label="Редакторам всех подсистем"
                  checked={notificationType.includes(3)}
                  onChange={value => handleCheckboxChange(3, value)}
                />
              </CheckboxListRow>
            </CheckboxListBlock>
          </GreyBlockWrapper>
          <GreyBlockWrapper>
            <Text
              text="Периодичность уведомлений"
              type="captionB"
              color={theme.colors.basic01}
            />
            <Select
              id="select-notifications-period"
              value={intervalType}
              options={[
                {title: 'Первый день каждого квартала', value: '1'},
                {title: 'Первый день каждого месяца', value: '2'},
                {title: 'Никогда', value: '3'},
              ]}
              label="Выберите из списка"
              onChange={setIntervalType}
            />
          </GreyBlockWrapper>
        </ModalContent>
        <ButtonsWrapper>
          <Button
            onClick={SaveNotificationsSettings}
            fullWidth
            title="Сохранить"
            variant="filled"
            disabled={!notificationType.length}
          />
          <Button
            fullWidth
            title="Отменить"
            onClick={() => {
              onCloseRequest();
            }}
          />
        </ButtonsWrapper>
      </ModalWrapper>
    </ModalWindow>
  );
};

export default EditNotificationsSettingsModal;
